/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xml_Feed_Rotate_KeyInputs */

const cs_xml_feed_rotate_key = /** @type {(inputs: Xml_Feed_Rotate_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit klíč`)
};

const en_xml_feed_rotate_key = /** @type {(inputs: Xml_Feed_Rotate_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotate key`)
};

/**
* | output |
* | --- |
* | "Rotate key" |
*
* @param {Xml_Feed_Rotate_KeyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const xml_feed_rotate_key = /** @type {((inputs?: Xml_Feed_Rotate_KeyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xml_Feed_Rotate_KeyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xml_feed_rotate_key(inputs)
	return cs_xml_feed_rotate_key(inputs)
});